import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import Form from '../ui/Form';

class TodosAllItem extends Form {

  state = {
    errors: {}
  }

  updateCheckbox = e => {
    e.preventDefault();
    e.stopPropagation();
    const val = this.props.data.todo_done ? 0 : 1;
    this.props.editTodo({
      todo_id: this.props.data.todo_id,
      todo_done: val
    }, errors => {
      if (errors) {
        this.setState({errors});
        return;
      }
      this.setState({errors: {}});
    });
  }

  render() {
    const { data, users, order, todolist } = this.props;
    const { errors } = this.state;
    const user = users.find(el => el.user_id === data.todo_user_id);
    const userName = user ? (user.user_fname + ' ' + user.user_lname) : '';
    return (
      <tr
        className={classnames({
          'text-danger': user && data.todo_dline <= moment().format('YYYY-MM-DD') && !data.todo_done
        })}
      >
        <td>
          <button
            type="button"
            className={classnames({
              btn: true,
              "btn-sm": true,
              "btn-success": !data.todo_done
            })}
            onClick={this.updateCheckbox}
          >
            <span
              className={classnames({
                glyphicon: true,
                "glyphicon-check": data.todo_done,
                "glyphicon-unchecked": !data.todo_done
              })}
            ></span>
          </button>
        </td>
        <td>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
          <span>{data.todo_desc}</span>
        </td>
        <td>
          {!!todolist && todolist.todolist_desc}
        </td>
        <td>
          {!!order && order.order_desc}
        </td>
        <td>
          {user ? moment(data.todo_dline).format('L') : ''}
        </td>
        <td>
          {userName}
        </td>
      </tr>
    );
  }
}

export default TodosAllItem;



// WEBPACK FOOTER //
// ./src/components/todo/TodosAllItem.js